import { createAction, props } from '@ngrx/store';
import { IPermissionModel, IRole } from '../models/role.model';

export const GetRoleList = createAction('[Permission] Get role list');
export const GetRoleListSuccess = createAction('[Permission] Get role list success', props<{ payload: IPermissionModel }>());
export const GetRoleListFailed = createAction('[Permission] Get role list failed', props<{ payload: Error }>());

export const EditRole = createAction('[Permission] edit role', props<{ payload: IRole }>());
export const EditRoleSuccess = createAction('[Permission] edit role success', props<{ payload: IRole }>());
export const EditRoleFailed = createAction('[Permission] edit role failed', props<{ payload: Error }>());

export const CreateRole = createAction('[Permission] create role', props<{ payload: IRole }>());
export const CreateRoleSuccess = createAction('[Permission] create role success', props<{ payload: IRole }>());
export const CreateRoleFailed = createAction('[Permission] create role failed', props<{ payload: Error }>());

export const DeleteRole = createAction('[Permission] delete role', props<{ payload: string }>());
export const DeleteRoleSuccess = createAction('[Permission] delete role success', props<{ payload: string }>());
export const DeleteRoleFailed = createAction('[Permission] delete role failed', props<{ payload: Error }>());

export const CloneRole = createAction('[Permission] clone role', props<{ payload: IRole }>());
export const CleanCloneRole = createAction('[Permission] clean clone role');
